module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Zwingen-093a69a619906e2747105b7284678c43.svg";